// extracted by mini-css-extract-plugin
module.exports = {"congratulations":"Congratulations_congratulations__24zPT","buttons":"Congratulations_buttons__2ZJ4A","gigSetupBtn":"Congratulations_gigSetupBtn__1WvoH"};